export const SIPCentralWhiteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <rect width="24" height="24" />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M12.5,4 L17.5,9 L14.8750884,11.6264542 C14.2474585,11.1802008 13.5371051,10.8574248 12.8253728,10.6746416 L14.5,9 L11,5.5 L12.5,4 Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M17,4 L22,9 L16.8059665,14.1958415 C16.5845879,13.4762561 16.186909,12.8463346 15.6817341,12.3200463 L19,9 L15.5,5.5 L17,4 Z"
        />
        <path
          fill="currentColor"
          d="M4.5,13 C4.5,12.2307692 5.5,9 8.5,9 C9.5,9 11.5,10 11.5,11.5 C12.5,11.5 15.9999553,12.5 15.9999553,15.5 C15.9999553,17 15.0000198,19 13.0000198,19 C9.50001975,19 8.07694283,19 5.00001975,19 C2.69232745,19 1.99754243,17.0722684 1.99995533,16 C2.50001975,13.5 4.5,13 4.5,13 Z"
        />
      </g>
    </svg>
  );
};
